const brand = process.env.REACT_APP_BRAND;

const theme = require(`./brands/${brand}/styles/theme`).default;

export default theme;